import { useEffect, useState } from "react";
import { useParams, Link } from "react-router";
import { api } from "../lib/api";
import { Badge } from "../components/primitives/Badge";
import { Pulse } from "../components/primitives/Pulse";

interface Transform {
  id: string;
  sourceConnectorType: string;
  destConnectorType: string;
  sourceObjectType?: string;
  destObjectType?: string;
  description?: string;
  hasParamsSchema?: boolean;
}

export function CatalogTransform() {
  const { id } = useParams<{ id: string }>();
  const [transform, setTransform] = useState<Transform | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api.listTransforms().then((r) => {
      const found = (r.transforms as Transform[]).find((t) => t.id === id) ?? null;
      setTransform(found);
    }).catch((e) => setError(e instanceof Error ? e.message : String(e)));
  }, [id]);

  if (error) return <p className="page-help">{error}</p>;
  if (!transform) return <Pulse />;

  return (
    <div style={{ maxWidth: 800 }}>
      <div style={{ marginBottom: 8 }}>
        <Link to="/catalog" className="uppercase-label">← CATALOG</Link>
      </div>
      <div className="uppercase-label">TRANSFORM</div>
      <h1 style={{ fontFamily: "var(--font-display)", fontSize: 28, margin: "4px 0 16px" }}>
        {transform.id}
      </h1>

      {transform.description && (
        <p className="page-help" style={{ maxWidth: 720 }}>{transform.description}</p>
      )}

      <section style={{ marginTop: 24 }}>
        <div className="uppercase-label" style={{ marginBottom: 8 }}>SHAPE</div>
        <dl style={{ display: "grid", gridTemplateColumns: "max-content 1fr", gap: "6px 16px" }}>
          <dt className="uppercase-label">SOURCE</dt>
          <dd className="mono" style={{ margin: 0 }}>
            <Link to={`/catalog/connectors/${transform.sourceConnectorType}`}>{transform.sourceConnectorType}</Link>
            {transform.sourceObjectType ? `:${transform.sourceObjectType}` : ""}
          </dd>
          <dt className="uppercase-label">DEST</dt>
          <dd className="mono" style={{ margin: 0 }}>
            <Link to={`/catalog/connectors/${transform.destConnectorType}`}>{transform.destConnectorType}</Link>
            {transform.destObjectType ? `:${transform.destObjectType}` : ""}
          </dd>
          <dt className="uppercase-label">PARAMS</dt>
          <dd style={{ margin: 0 }}>
            {transform.hasParamsSchema ? <Badge tone="ok">CONFIGURABLE</Badge> : <Badge tone="muted">NONE</Badge>}
          </dd>
        </dl>
      </section>
    </div>
  );
}
